import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-body" }
const _hoisted_2 = { class: "share-button-container" }
const _hoisted_3 = { id: "footer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "get-link" }, [
  /*#__PURE__*/_createTextVNode("Get yours on "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://doglink.net",
    target: "_blank"
  }, "doglink.net")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareButton = _resolveComponent("ShareButton")!
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_SocialNetworkList = _resolveComponent("SocialNetworkList")!
  const _component_SectionItemList = _resolveComponent("SectionItemList")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ShareButton)
      ]),
      _createVNode(_component_HeaderSection, {
        tagline: _ctx.tagline,
        username: _ctx.title ? _ctx.title : '@' + _ctx.username,
        avatar: _ctx.avatar
      }, null, 8, ["tagline", "username", "avatar"]),
      _createVNode(_component_SocialNetworkList),
      _createVNode(_component_SectionItemList)
    ]),
    _createElementVNode("footer", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_router_link, { to: "terms-of-service" }, {
        default: _withCtx(() => [
          _createTextVNode("Terms of Service")
        ]),
        _: 1
      }),
      _createTextVNode(" | "),
      _createVNode(_component_router_link, { to: "privacy-policy" }, {
        default: _withCtx(() => [
          _createTextVNode("Privacy Policy")
        ]),
        _: 1
      })
    ])
  ], 64))
}